<template>
  <tr>
    <th class="w-8"></th>
    <th class="w-px">
      <span class="5xl:pl-3! 5xl:pr-16 inline-flex h-full w-full justify-start">
        <RfFilter
          data-cy="filters--segment-status"
          hideIcon
          tableStyle
          activator="Status"
          explicit
          :groups="{ statuses: { el: Statuses, key: 'type', value: 'title' } }"
          :selected="filters"
          @selected="items => emit('update:filters', { ...filters, ...items })"
        />
      </span>
    </th>
    <th class="pl-0!">
      <RfSortButton
        data-cy="filters--segment-name"
        :filtered="sort.type === 'name' ? sort.value : null"
        class="h-full w-full"
        @click="value => emit('update:sort', { type: 'name', value })"
      >
        Segment name
      </RfSortButton>
    </th>
    <th class="3xl:w-96 5xl:w-136 w-60">
      <RfFilter
        hideIcon
        tableStyle
        activator="Configuration"
        disabled
        class="rf-header--configuration h-full w-full [&.rf-menu_.rf-menu--button]:mr-auto [&.rf-menu_.rf-menu--button]:ml-0 [&.rf-menu_.rf-menu--button]:justify-start"
      />
    </th>
    <th class="5xl:w-44 w-36">
      <RfSortButton
        :filtered="sort.type === 'created_at' ? sort.value : null"
        data-cy="filters--segment-date"
        class="h-full w-full justify-center whitespace-pre"
        @click="value => emit('update:sort', { type: 'created_at', value })"
      >
        Creation date
      </RfSortButton>
    </th>
    <th class="5xl:w-44 w-32">
      <RfSortButton
        :filtered="sort.type === 'path_count' ? sort.value : null"
        disabled
        class="whitespace-pre"
        @click="value => emit('update:sort', { type: 'path_count', value })"
      >
        Used in Prompts
      </RfSortButton>
    </th>
    <th class="bg-goal 5xl:w-44 w-32">
      <RfSortButton
        :filtered="sort.type === 'users' ? sort.value : null"
        class="pointer-events-none whitespace-pre"
        disabled
        @click="value => emit('update:sort', { type: 'conversion', value })"
      >
        Total users
      </RfSortButton>
    </th>
    <th class="w-10"></th>
  </tr>
</template>

<script setup>
import RfSortButton from "@/components/buttons/RfSortButton.vue";
import RfFilter from "@/components/inputs/RfFilter.vue";
import { Statuses } from "@/utils/constants/SegmentsConstants";

const emit = defineEmits(["update:filters", "update:sort"]);

defineProps({
  filters: { type: Object, default: null },
  sort: { type: Object, default: null },
  getAppDevices: { type: Array, default: () => [] },
  segments: { type: Array, default: () => [] },
  performanceCols: { type: Boolean, default: false },
});
</script>
